import styled from "styled-components";

export const Background = styled.div`
  width: 100%;
  margin: 0;
  padding: 10px 0;
  background-color: #f0f0f0;

  @page {
    size: A4 portrait;
    margin: 1cm;
  }

  @media print {
    width: 210mm;
    min-height: 297mm;
  }
`;

export const Page = styled.div`
  width: 210mm;
  min-height: 297mm;
  padding: 8mm;
  margin: 10mm auto;
  background: white;

  @media print {
    margin: 0;
    box-shadow: none;
    page-break-after: always;
  }
`;

export const Subpage = styled.div`
  width: 100%;
`;

export const Images = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-around;
  align-items: center;
  margin-bottom: 24px;

  img {
    &:nth-child(1) {
      height: 60px;
    }

    &:nth-child(2) {
      height: 40px;
    }
  }
`;

export const Content = styled.div`
  width: 100%;
  color: #000;
`;

export const Title = styled.h1`
  font-size: 18px;
  text-align: center;
  margin: 8px 0 18px;
`;

export const BlockTitle = styled.h2`
  font-size: 13px;
  margin: 18px 0 10px;
  font-weight: 700;
  text-transform: uppercase;
`;

export const Paragraph = styled.p`
  font-size: 12px;
  line-height: 1.5;
  text-align: justify;
  margin: 14px 0 20px;
`;

export const InfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 8px 18px;
  margin: 12px 0;
`;

export const InfoItem = styled.div`
  font-size: 12px;
`;

export const SubLabel = styled.h3`
  font-size: 12px;
  margin: 12px 0 8px;
  font-weight: 700;
`;

export const Note = styled.p`
  font-size: 11px;
  line-height: 1.5;
  margin: 8px 0 14px;
`;

export const SectionTitle = styled.h2`
  font-size: 14px;
  margin: 14px 0 6px;
`;

export const UnidadeBlock = styled.section`
  margin-bottom: 8px;

  @media print {
    break-inside: avoid;
    break-inside: avoid-page;
    page-break-inside: avoid;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  margin-bottom: 16px;

  th,
  td {
    border: 1px solid #000;
    padding: 5px;
    text-align: left;
    vertical-align: top;
  }
  tr .nome {
    width: 80%;
  }
  th {
    text-transform: uppercase;
    text-align: center;
  }

  .right {
    text-align: right;
  }

  .cargaTh {
    width: 10%;
  }
  .carga {
    text-align: center;
  }
`;

export const PlaceDate = styled.div`
  width: 100%;
  margin-top: 18px;
  margin-bottom: 24px;
  text-align: center;
  font-size: 12px;
`;

export const SignatureRow = styled.div`
  margin-top: 40px;
  display: flex;
  justify-content: center;

  div {
    text-align: center;
    width: 360px;
  }

  span {
    display: block;
    font-size: 12px;
  }

  p {
    margin-top: 8px;
    font-size: 12px;
  }
`;
